import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

//HOOKS
import useStandingsHandler from "../../hooks/useStandingsHandler";

export default function StandingsSelect({ selected, callback, disabled = false, override = false, customLabel = null, backgroundColor = null }) {
   const [
      standings,
      setStandings,
      cachedStandings,
      tournamentRounds,
      notification,
      { getCachedStandings },
   ] = useStandingsHandler();

   useEffect(() => {
      getCachedStandings();
   }, []);

   const handleChange = (e) => {
      let roundName;
      let roundId = e.target.value;
      if (roundId === '0') {
         roundName = 'MostRecent';
      } else if (roundId === '9999999') {
         roundName = 'Round 0';
      } else { 
         roundName = _.find(cachedStandings, { RoundId: e.target.value }).description;
      }

      if (e.target.name && e.target.value) {
         callback({ id: roundId, value: roundName });
      }
   };

   return (
      <>
         {cachedStandings && !disabled && (
            <Box sx={{ py: 2, px: 4, backgroundColor: backgroundColor ? backgroundColor : "#fff", width: "100%" }}>
               <Stack direction="row" spacing={2}>
               <FormControl fullWidth sx={{ maxWidth: 400 }}>
                  <InputLabel id={"StandingsSelect"}>{customLabel ? customLabel : "Standings"}</InputLabel>
                  
                  <Select
                     value={selected !== 0 ? selected : 0}
                     label={"Standings"}
                     name={"StandingsId"}
                     onChange={handleChange}
                  >
                     {!override && <MenuItem value='0'>Most recent Standings</MenuItem>}
                     <MenuItem value='9999999'>Round 0 (Alphabetical)</MenuItem>
                     {cachedStandings.map((standings) => (
                        <MenuItem
                           key={standings.RoundId}
                           value={standings.RoundId}
                        >
                           {standings.description}
                        </MenuItem>
                     ))}
                  </Select>
               </FormControl>

               {override && (
                  <Button variant="outlined" color="primary" onClick={() => callback({id: null, value: null})}>Clear Override</Button>
               )}
               </Stack>
            </Box>
         )}
         {cachedStandings && disabled && (
            <>
               {
                  _.find(cachedStandings, { RoundId: selected }) ? _.find(cachedStandings, { RoundId: selected }).description : "Most recent Standings"
               }
            </>
         )}
         </>
   );
}
